import { controls,grouped } from "../controls";
const interest_structures = {
label: "Interest Structures",
pageLabel: "Interest Structures",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:false} },
pageType: "history",
formTabs:
 {allTabs: [
{ label: "General", uid: "general" },
{label: "Interest Rates",uid: "interest_rates"}
]},
filter:[
...controls.displayText({ tab: "filter", label: "Code"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "interest_structure_code",maxlength:10}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Description",description:'Starting partial search. e.g. You can search for Sugar Cane by typing sugar.'}),
...controls.text({ tab: "filter",  placeHolder: "", name: "interest_structure_display%",maxlength:50}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
]
,form:[
...controls.displayText({ tab: "general", label: "Code",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "interest_structure_code",isRequired:false,maxlength:10}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Description",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "interest_structure_display",isRequired:false,maxlength:50}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Interest Calculation Type",star:false}),
...controls.oc({ tab: "general", c: "InterestCalculationType", placeHolder: "Interest Calculation Type Code", name: "interest_calculation_type_code", isRequired:false,fastpath:"interest_calculation_types",autoopen:true}),
...controls.showData({ tab: "general", displaytype: "capital", data: "interest_calculation_type_display"}),
...controls.displayText({ tab: "general", label: "Interest Frequency",star:false}),
...controls.oc({ tab: "general", c: "InterestFrequency", placeHolder: "Interest Frequency Code", name: "interest_frequency_code", isRequired:false,fastpath:"interest_frequencies",autoopen:true}),
...controls.showData({ tab: "general", displaytype: "capital", data: "interest_frequency_display"}),
...controls.displayText({ tab: "general", label: "Interest Frequency",star:false}),
...controls.oc({ tab: "general", c: "InterestFrequency", placeHolder: "Interest Frequency Code", name: "interest_frequency_code", isRequired:false,fastpath:"interest_frequencies",autoopen:true}),
...controls.showData({ tab: "general", displaytype: "capital", data: "interest_frequency_display"}),
...controls.displayText({ tab: "general", label: "Interest On Type",star:false}),
...controls.oc({ tab: "general", c: "InterestOnType", placeHolder: "Interest On Type Code", name: "interest_on_type_code", isRequired:false,fastpath:"interest_on_types",autoopen:true}),
...controls.showData({ tab: "general", displaytype: "capital", data: "interest_on_type_display"}),
...controls.magicDateLabel({ tab: "interest_rates", label: "Trdate",target: "trdate",star:false}),
...controls.magicDate({ tab: "interest_rates", name: "trdate", dateType: "ontype",isRequired:false }),
...controls.displayText({ tab: "interest_rates", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "interest_rates", label: "From Amount"}),
...controls.floatOnly({ tab: "interest_rates",  placeHolder: "", name: "from_amount",maxlength:18}),
...controls.displayText({ tab: "interest_rates", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "interest_rates", label: "To Amount"}),
...controls.floatOnly({ tab: "interest_rates",  placeHolder: "", name: "to_amount",maxlength:18}),
...controls.displayText({ tab: "interest_rates", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "interest_rates", label: "From Months",star:false}),
...controls.numberOnly({ tab: "interest_rates",  placeHolder: "", name: "from_months",isRequired:false,maxlength:200}),
...controls.displayText({ tab: "interest_rates", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "interest_rates", label: "To Months",star:false}),
...controls.numberOnly({ tab: "interest_rates",  placeHolder: "", name: "to_months",isRequired:false,maxlength:200}),
...controls.displayText({ tab: "interest_rates", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "interest_rates", label: "From Days",star:false}),
...controls.numberOnly({ tab: "interest_rates",  placeHolder: "", name: "from_days",isRequired:false,maxlength:200}),
...controls.displayText({ tab: "interest_rates", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "interest_rates", label: "To Days",star:false}),
...controls.numberOnly({ tab: "interest_rates",  placeHolder: "", name: "to_days",isRequired:false,maxlength:200}),
...controls.displayText({ tab: "interest_rates", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "interest_rates", label: "Int Rate"}),
...controls.floatOnly({ tab: "interest_rates",  placeHolder: "", name: "int_rate",maxlength:8}),
...controls.displayText({ tab: "interest_rates", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "interest_rates", label: "Senior Rate"}),
...controls.floatOnly({ tab: "interest_rates",  placeHolder: "", name: "senior_rate",maxlength:8}),
...controls.displayText({ tab: "interest_rates", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "interest_rates", label: "Staff Rate"}),
...controls.floatOnly({ tab: "interest_rates",  placeHolder: "", name: "staff_rate",maxlength:8}),
...controls.displayText({ tab: "interest_rates", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "interest_rates", label: "Woman Rate"}),
...controls.floatOnly({ tab: "interest_rates",  placeHolder: "", name: "woman_rate",maxlength:8}),
...controls.displayText({ tab: "interest_rates", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "interest_rates", label: "Society Rate"}),
...controls.floatOnly({ tab: "interest_rates",  placeHolder: "", name: "society_rate",maxlength:8}),
...controls.displayText({ tab: "interest_rates", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "interest_rates", label: "Demography",star:false}),
...controls.oc({ tab: "interest_rates", c: "Demography", placeHolder: "Demography Code", name: "demography_code", isRequired:false,fastpath:"demographies"}),
...controls.showData({ tab: "interest_rates", displaytype: "capital", data: "demography_display"}),

...controls.displayText({ tab:"interest_rates" ,width:"col-sm-12", label: "" }),
...controls.displayText({ tab:"interest_rates" ,width:"col-sm-4", label: "" }),
...controls.button({
tab:"interest_rates",
 label: "ADD",
 style: { padding: 0 },
Bcolor: "success",
 onclick: {
  action: "appendToHTMLTable",
  tableNameField: "interest_rates",
  requiredField: ["trdate","from_amount","to_amount","from_months","to_months","from_days","to_days","int_rate","senior_rate","staff_rate","woman_rate","society_rate","demography_code","demography_display","demography_uid",]
}, width: "col-sm-2"
}),
...controls.button({
tab:"interest_rates",
 label: "CLEAR",
 style: { padding: 0 },
Bcolor: "warning",
 onclick: {
  action: "clearForm",
  tableNameField: "interest_rates",
  requiredField: ["trdate","from_amount","to_amount","from_months","to_months","from_days","to_days","int_rate","senior_rate","staff_rate","woman_rate","society_rate","demography_code","demography_display","demography_uid",]
}, width: "col-sm-2"
}),
{
  tab:"interest_rates",
inputType: "table",
  tableTitle: "",
  deletable: true,
  editable: true,
  tableHeaders: [
    { label: "Sr", type: "autoinc" },
    { label: "Trdate", field: "trdate", displaytype: "date"},
    { label: "From Amount", field: "from_amount"},
    { label: "To Amount", field: "to_amount"},
    { label: "From Months", field: "from_months"},
    { label: "To Months", field: "to_months"},
    { label: "From Days", field: "from_days"},
    { label: "To Days", field: "to_days"},
    { label: "Int Rate", field: "int_rate"},
    { label: "Senior Rate", field: "senior_rate"},
    { label: "Staff Rate", field: "staff_rate"},
    { label: "Woman Rate", field: "woman_rate"},
    { label: "Society Rate", field: "society_rate"},
    { label: "Demography Code", field: "demography_code"},
    { label: "Demography Display", field: "demography_display"},
  ],
  widths: {
    parent: "col-sm-12",
    children: "col-sm-12"
  },
  name: "interest_rates"
},
]
,history:{
perPage: 10,
reportHeader: "Interest Structures",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Interest Structure Code",accessor: "interest_structure_code",},
{Header: "Interest Structure",accessor: "interest_structure_display",},
{Header: "Interest Calculation Type Id",accessor: "interest_calculation_type_id",},
{Header: "Interest Calculation Frequency Id",accessor: "interest_calculation_frequency_id",},
{Header: "Interest Payout Frequency Id",accessor: "interest_payout_frequency_id",},
{Header: "Interest Calculation On Id",accessor: "interest_calculation_on_id",},
{Header: "Interest Structure Active",accessor: "interest_structure_active",type:'tick'},
]}};
export default interest_structures;